import { useState } from 'react'

type Direction = 'left' | 'right'

const useHorizontalSwipe = (
  handleTouchEnd: (direction: Direction, distance: number) => void,
  minSwipeDistance = 30,
) => {
  const [touchStart, setTouchStart] = useState(null)
  const [touchEnd, setTouchEnd] = useState(null)

  const onTouchStart = (e) => {
    setTouchEnd(null)
    setTouchStart(e.targetTouches[0].clientX)
  }

  const onTouchMove = (e) => setTouchEnd(e.targetTouches[0].clientX)

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return

    const distance = touchStart - touchEnd
    const isPositiveDistance = Math.sign(distance) === 1

    if (isPositiveDistance && distance <= minSwipeDistance) return
    if (!isPositiveDistance && distance >= -minSwipeDistance) return

    handleTouchEnd(distance > 0 ? 'left' : 'right', distance)
  }

  return { onTouchStart, onTouchEnd, onTouchMove }
}

export default useHorizontalSwipe
